var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "create-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.998,
    height: 19.998,
    viewBox: "0 0 19.998 19.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M62.229,128.922H50.692A2.7,2.7,0,0,1,48,126.229V114.692A2.7,2.7,0,0,1,50.692,112h8.051a.769.769,0,0,1,0,1.538H50.692a1.155,1.155,0,0,0-1.154,1.154v11.537a1.155,1.155,0,0,0,1.154,1.154H62.229a1.155,1.155,0,0,0,1.154-1.154v-8.845a.769.769,0,0,1,1.538,0v8.845A2.7,2.7,0,0,1,62.229,128.922Z",
    transform: "translate(-48 -108.923)",
    fill: "#006664"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M220.11,48.252a.772.772,0,0,0-1.116-.027l-.595.592a.385.385,0,0,0,0,.544l.545.544a.385.385,0,0,0,.545,0l.58-.577A.782.782,0,0,0,220.11,48.252ZM217.2,50.019l-8.678,8.663a.432.432,0,0,0-.111.189l-.4,1.2a.188.188,0,0,0,.234.234l1.195-.4a.433.433,0,0,0,.189-.111l8.663-8.679a.433.433,0,0,0,0-.609l-.478-.481A.433.433,0,0,0,217.2,50.019Z",
    transform: "translate(-200.307 -48)",
    fill: "#006664"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.550fad10590ac2cb551ed40b3f8c7eb6.svg";
export { ForwardRef as ReactComponent };